import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { CUSTOMER_USER_HOME, isCustomerUserAllowedUrl } from '../utils/customer-user-access.util';

/**
 * ERPPDV-2483: o usuário externo do cliente só navega pelos álbuns de fotos. Qualquer outra tela
 * (inclusive o `''` → dashboard depois do login) volta para a lista de álbuns. Usuário interno passa
 * direto.
 */
export const customerUserGuard: CanActivateChildFn = (_route, state) => {
  const authService = inject(AuthService);

  if (!authService.isCustomerUser() || isCustomerUserAllowedUrl(state.url)) {
    return true;
  }

  return inject(Router).parseUrl(CUSTOMER_USER_HOME);
};
